import { render } from "./editpurchase.vue?vue&type=template&id=1bc0f989&scoped=true"
import script from "./editpurchase.vue?vue&type=script&lang=js"
export * from "./editpurchase.vue?vue&type=script&lang=js"

import "./editpurchase.vue?vue&type=style&index=0&id=1bc0f989&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc0f989"]])

export default __exports__